import { useEffect, useState } from 'react';
import { Box, Typography, Switch, FormControlLabel, Alert, CircularProgress } from '@mui/material';
import { getConfig, setConfig } from '../../api/systemConfigApi';

const PP = "'Poppins', sans-serif";

// Super Admin toggle for app-wide Maintenance Mode (stored in SystemConfig key
// "MaintenanceMode"). When ON, non-admin users see MaintenancePage everywhere except
// pricing tools / resources / tutorials. Super Admins are never blocked.
export default function MaintenanceTab() {
    const [on, setOn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        getConfig('MaintenanceMode')
            .then(r => setOn(String(r?.data?.value).toLowerCase() === 'true'))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const toggle = async (next) => {
        setSaving(true);
        try {
            await setConfig('MaintenanceMode', next ? 'true' : 'false');
            setOn(next);
        } catch (e) {
            alert('Could not update maintenance mode: ' + (e?.response?.data || e?.message || 'error'));
        } finally { setSaving(false); }
    };

    if (loading) return <CircularProgress />;

    return (
        <Box sx={{ maxWidth: 560 }}>
            <Typography sx={{ fontFamily: PP, fontWeight: 700, fontSize: '1rem', color: '#0F172A', mb: 1 }}>
                Maintenance Mode
            </Typography>
            <Typography sx={{ fontFamily: PP, fontSize: '0.85rem', color: '#64748B', mb: 2 }}>
                When ON, every user sees an &ldquo;Under maintenance&rdquo; page across the app.
                <b> Pricing tools, resources and tutorials stay accessible</b>, and Super Admins are never
                blocked (so you can turn it back off). Use it before a deploy or any disruptive change.
            </Typography>
            {on && (
                <Alert severity="warning" sx={{ mb: 2, fontFamily: PP, fontSize: '0.82rem' }}>
                    Maintenance mode is currently <b>ON</b> &mdash; most pages are blocked for non-admin users.
                </Alert>
            )}
            <FormControlLabel
                control={<Switch checked={on} disabled={saving} onChange={(e) => toggle(e.target.checked)} color="warning" />}
                label={<span style={{ fontFamily: PP, fontWeight: 600 }}>{on ? 'Maintenance ON' : 'Maintenance OFF'}</span>}
            />
        </Box>
    );
}
